import { createSelector } from 'reselect';
import PreAdviceTransactionsHistoryColumns from '../../containers/PreAdviceTransactionsHistoryColumns';
import TableDefinitions from '../../../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.PREADVICE_TRANSACTIONS_HISTORY.isLoading;
export const getData = TableDefinitions.PREADVICE_TRANSACTIONS_HISTORY.getDataFunction();
export const getColumns = createSelector(getData, PreAdviceTransactionsHistoryColumns);
